"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbIdValidationSchema = void 0;
const yup_1 = require("yup");
exports.dbIdValidationSchema = (0, yup_1.number)()
    .typeError("form.validations.badInput")
    .required("form.validations.valueMissing")
    .min(1, "form.validations.rangeUnderflow");
//# sourceMappingURL=dbId.js.map